import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { findPriceCalloutOrInitialize } from "@circle-react/helpers/paywallCustomizationHelpers";
import { useGetPaywallsCurrencies } from "@circle-react/hooks/paywalls/useGetPaywallsCurrencies";
import type { PaywallCurrency } from "@circle-react/types";
import { StripePricingTabContextProvider } from "../../../PricingTab/StripePricingTab/hooks/usePricingTabContext";
import { useCheckoutTabContext } from "../../CheckoutTabContext";
import { RowSidebar } from "../components/RowSidebar";
import { CalloutColorField } from "./CalloutColorField";
import { PriceCalloutForm } from "./PriceCalloutForm";

const formRootName =
  "paywall_customization_attributes.price_callout_properties";

export const PriceCalloutsForm = () => {
  const fields = {
    callout_color: [formRootName, "callout_color"].join("."),
    prices: [formRootName, "prices"].join("."),
  };
  const { priceCalloutPropertiesForm } = useCheckoutTabContext();
  const { watch, setValue, getValues } = useFormContext();

  const stripePrices = watch("stripe_prices_attributes");
  useEffect(() => {
    setValue(
      "paywall_customization_attributes.price_callout_properties.prices",
      findPriceCalloutOrInitialize(
        stripePrices,
        priceCalloutPropertiesForm?.fields || [],
      ),
    );
  }, []);

  const onClick = (inputIndex: number, isHighlighted: boolean) => {
    const priceCallouts = getValues(fields.prices) || [];
    setValue(
      "paywall_customization_attributes.price_callout_properties.prices",
      priceCallouts.map((priceCallout: any, index: number) => ({
        ...priceCallout,
        highlighted: isHighlighted ? false : index === inputIndex,
      })),
      { shouldDirty: true },
    );
  };

  const currencyId = Number(getValues("currency_id"));
  const currenciesQuery = useGetPaywallsCurrencies();
  const currency = (currenciesQuery?.data || []).find(
    (currency: PaywallCurrency) => currency.id === currencyId,
  );
  if (!currency) {
    return null;
  }

  return (
    <>
      <CalloutColorField name={fields.callout_color} />
      <StripePricingTabContextProvider currency={currency}>
        <RowSidebar className="flex flex-col gap-y-5">
          {priceCalloutPropertiesForm?.fields?.map(
            (priceCallout: any, index: number) => (
              <PriceCalloutForm
                key={priceCallout.price_id}
                priceCallout={priceCallout}
                index={index}
                onClick={onClick}
              />
            ),
          )}
        </RowSidebar>
      </StripePricingTabContextProvider>
    </>
  );
};
